
import { Component, Vue } from "vue-property-decorator";
import { modal } from "@/store/modal";
@Component({})
export default class AboutUs extends Vue {
  modal: any = modal;
}
